import { render, staticRenderFns } from "./AllBanksTable.vue?vue&type=template&id=33e8cd1a&scoped=true&"
import script from "./AllBanksTable.vue?vue&type=script&lang=js&"
export * from "./AllBanksTable.vue?vue&type=script&lang=js&"
import style0 from "./AllBanksTable.vue?vue&type=style&index=0&id=33e8cd1a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e8cd1a",
  null
  
)

export default component.exports